import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { TellentAssistantEngagementsActions } from '@core/tellent-assistant-data';

@Injectable({ providedIn: 'root' })
export class EngagementsDataService {
  private readonly store = inject(Store);

  public recordEngagement(id: string): void {
    this.store.dispatch(TellentAssistantEngagementsActions.record({ payload: { id } }));
  }
}
